module.exports = {
  RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_REQUEST: 'RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_REQUEST',
  RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_SUCCESS: 'RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_SUCCESS',
  RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_FAILURE: 'RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_FAILURE',
  ARRIVAL_MRD_MAIL_PROCESSING_CENTER_CHECKED: 'ARRIVAL_MRD_MAIL_PROCESSING_CENTER_CHECKED',
  ARRIVAL_MRD_POSTAL_OPERATOR_EXPANDED: 'ARRIVAL_MRD_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_ARRIVAL_MRD_MAIL_PROCESSING_CENTERS: 'SELECT_ALL_ARRIVAL_MRD_MAIL_PROCESSING_CENTERS',
  DESELECT_ALL_ARRIVAL_MRD_MAIL_PROCESSING_CENTERS: 'DESELECT_ALL_ARRIVAL_MRD_MAIL_PROCESSING_CENTERS',
};
